import { render } from "./OrderCenter.vue?vue&type=template&id=6736ca2f&scoped=true"
import script from "./OrderCenter.vue?vue&type=script&lang=js"
export * from "./OrderCenter.vue?vue&type=script&lang=js"

import "./OrderCenter.vue?vue&type=style&index=0&id=6736ca2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6736ca2f"]])

export default __exports__